import { getUserInfo } from '@/api/login'
import { removeToken } from '@/libs/session'
import router from "@/router/index"
export default {
  // 获取用户信息
  getUserInfo ({ commit }) {
    return new Promise((resolve, reject) => {
      try {
        getUserInfo().then(response => {
          if (response.data) {
            commit('setUserInfo', response.data)
            commit('setHasUserInfo', true)
            resolve(response.data)
          }
        }).catch(error => {
          console.log(error);
          if(error.code == 400 && error.status == 401){
            removeToken();
            router.push({name: "login"});
          }
          reject(error)
        })
      } catch (error) {
        reject(error)
      }
    })
  },
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      try {
        commit('setUserInfo', {})
        commit('setHasUserInfo', false)
        removeToken();
        //清空登录cookies
        document.cookie =
        "remember_me=0;domain=.dengyuan.vip;expires=" +
        new Date(0).toGMTString() +
        ";path=/";
        document.cookie =
        "token=0;domain=guide.dengyuan.vip;expires=" +
        new Date(0).toGMTString() +
        ";path=/";
        router.push({name: "login"});
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js